'use client';

import { createContext, useContext } from 'react';

import { useSwitchFlexToWhatsappCities } from '@/feature-flags/hooks/use-switch-flex-to-whatsapp-cities.hook';
import type { UseSwitchFlexToWhatsappCitiesResult } from '@/feature-flags/types/switch-flex-to-whatsapp.types';

const SwitchFlexToWhatsappContext = createContext<UseSwitchFlexToWhatsappCitiesResult>({
  cities: [],
  loading: true,
  error: null,
  isFallback: true,
  refetch: async () => {},
  variant: null,
});

interface SwitchFlexToWhatsappProviderProps {
  children: React.ReactNode;
}

export function SwitchFlexToWhatsappProvider({ children }: SwitchFlexToWhatsappProviderProps) {
  const state = useSwitchFlexToWhatsappCities();

  return (
    <SwitchFlexToWhatsappContext.Provider value={state}>
      {children}
    </SwitchFlexToWhatsappContext.Provider>
  );
}

export function useSwitchFlexToWhatsappContext(): UseSwitchFlexToWhatsappCitiesResult {
  const context = useContext(SwitchFlexToWhatsappContext);

  if (!context) {
    throw new Error('useSwitchFlexToWhatsappContext must be used within SwitchFlexToWhatsappProvider');
  }

  return context;
}
